import type { FunctionComponent, ReactNode } from 'react';
import { useMemo, useReducer } from 'react';

import SeedOrdersContext from './SeedOrdersContext';
import { getActions } from './actions';
import { initialState, reducer } from './reducer';

const SeedOrdersProvider: FunctionComponent<{ children: ReactNode }> = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, initialState);
  const actions = useMemo(() => getActions(dispatch), [dispatch]);

  return (
    <SeedOrdersContext.Provider value={{ actions, state }}>{children}</SeedOrdersContext.Provider>
  );
};

export default SeedOrdersProvider;
